import { ResourceTypeId } from "@/helpers/resource-type-id";

const shipTextPattern = /Schiffsupgrade-Menu(?:.*[ \t]*\n)*?.*?Level[ \t]+([0-9`]+) \(\+([0-9`]+)\).*\n.*[ \t]+([0-9`]+)(?:.*\n)*.*LvL[ \t]*\n((?:.* \([0-9`]+\).*(?:\n|$))+)/;
const bonusPattern = /(.*) \(([0-9`]+)\).*(?:\n|$)/;

const SpecialShipImporter = {
  import(data) {
    const shipTextMatch = data.match(shipTextPattern);
    if (!shipTextMatch) {
      return null;
    }
    let level =
      this.getNumber(shipTextMatch[1]) + this.getNumber(shipTextMatch[2]);
    let exp = this.getNumber(shipTextMatch[3]);
    let levelups = this.getLevelups(shipTextMatch[4]);
    return {
      level: level,
      exp: exp,
      levelups: levelups
    };
  },
  getLevelups(levelupsData) {
    let entryMatches = [];
    let entryMatch;
    while ((entryMatch = bonusPattern.exec(levelupsData)) !== null) {
      entryMatches.push(entryMatch);
      levelupsData = levelupsData.substring(
        entryMatch.index + entryMatch[0].length
      );
    }
    const result = {};
    entryMatches.forEach(match => {
      const typeName = match[1];
      const level = this.getNumber(match[2]);
      const typeId = this.getTypeFromName(typeName);
      result[typeId] = level;
    });
    return result;
  },
  getNumber(text) {
    return parseInt(text.replace("`", ""));
  },
  getTypeFromName(name) {
    switch (name) {
      case "Waffen":
        return ResourceTypeId.WEAPONS;
      case "Panzerung":
        return ResourceTypeId.ARMOR;
      case "Schild":
        return ResourceTypeId.SHIELDS;
      case "Heilung":
        return ResourceTypeId.REGENERATION;
      case "Kapazität":
        return ResourceTypeId.CAPACITY;
      case "Speed":
        return ResourceTypeId.FLIGHT_SPEED;
      case "Besatzung":
        return ResourceTypeId.PILOTS;
      case "Tarnung":
        return ResourceTypeId.STEALTH;
      case "Giftgas":
        return ResourceTypeId.POISON;
      case "Techklau":
        return ResourceTypeId.ESPIONAGE;
      case "Bombardierung":
        return ResourceTypeId.BOMBARDMENT;
      case "Antrax":
        return ResourceTypeId.ANTRAX;
      case "EMP":
        return ResourceTypeId.EMP;
      case "Bereitschaft":
        return ResourceTypeId.READINESS;
    }
  }
};

export { SpecialShipImporter };
